import { render, staticRenderFns } from "./xctfllist.vue?vue&type=template&id=656a0974&scoped=true"
import script from "./xctfllist.vue?vue&type=script&lang=js"
export * from "./xctfllist.vue?vue&type=script&lang=js"
import style0 from "./xctfllist.vue?vue&type=style&index=0&id=656a0974&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a0974",
  null
  
)

export default component.exports